import InAppMessage from "./in-app-message.js";
export default class HtmlMessage extends InAppMessage {
  constructor(i, o, d, v, s, t, e, r, u, h, n) {
    super(
      i,
      void 0,
      void 0,
      o,
      d,
      void 0,
      void 0,
      void 0,
      (v = v || InAppMessage.DismissType.MANUAL),
      s,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      t,
      e,
      void 0,
      void 0,
      void 0,
      r,
      void 0,
      void 0,
      void 0,
      u,
      h
    ),
      (this.messageFields = n),
      (this.messageFields = n);
  }
  io() {
    return !1;
  }
  p(i) {
    if (this.Ce === InAppMessage.Ee.do) {
      if (this.vo) return !1;
      this.vo = !0;
    }
    return this.ht.Et(i), !0;
  }
}
HtmlMessage.es = InAppMessage.Ee.do;
